import axios from 'axios';

// Get API configuration from environment variables
const API_URL = process.env.REACT_APP_API_URL || 'https://adminapi-k4m2a.k4m2a.p.azurewebsites.net/';
// const API_URL = process.env.REACT_APP_API_URL || 'https://demoapi.filtechsolutions.co.in';
// const API_URL = process.env.REACT_APP_API_URL || 'https://localhost:7289';

const API_BASE_PATH = process.env.REACT_APP_API_BASE_PATH || '/api';

// Create axios instance with default configuration
const apiClient = axios.create({
  baseURL: `${API_URL}${API_BASE_PATH}`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized - Clear token and redirect to login
    if (error.response?.status === 401) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      localStorage.removeItem('tenantId');
      // Redirect to login page if not already there
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }

    // Handle 403 Forbidden
    if (error.response?.status === 403) {
      console.error('Access forbidden:', error.response.data);
    }

    // Handle network errors
    if (!error.response) {
      console.error('Network error:', error.message);
    }

    return Promise.reject(error);
  }
);

export default apiClient;
export { API_URL, API_BASE_PATH };

